import { useUserQrQuery, useWorkerQrQuery } from '../queries/users'

/**
 * Get the QR code of a user
 * @param userId - The id of the user to get the QR code of
 * @param isExternalWorker - Whether the user is an external worker
 * @returns The QR code of the user
 */
const useQrCode = (
  userId: string,
  isExternalWorker?: boolean,
  forceDisabled?: boolean,
): string | undefined => {
  const currentQrQuery = useUserQrQuery(userId, {
    enabled: !isExternalWorker && !forceDisabled,
  })
  const currentWorkerQrQuery = useWorkerQrQuery(userId, {
    enabled: isExternalWorker && !forceDisabled,
  })
  return currentQrQuery.data || currentWorkerQrQuery.data
}

export default useQrCode
